module.exports = __webpack_public_path__ + "media/tentacle.c3752e35.mp3";